import { FETCH_APP_CONFIG } from '../actions/actionTypes';

function appConfig (state={}, action) {
    const { type, payload } = action;
    switch(type) {
        case FETCH_APP_CONFIG:
            payload.forEach( config => {
                state = { ...state, ...config};
            })
            return state;
        default:
            return state;
    }
}

export default appConfig;
